(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-copyright"] && !Shopify.designMode) return;
  try {
    (function () {
    const roots = document.querySelectorAll('[data-roulette]');
    if (!roots.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach((root) => {
      const track = root.querySelector('[data-roulette-track]');
      if (!track) return;
      const count = parseInt(root.dataset.count, 10) || 12;
      const trigger = root.closest('.website-by') || root;
      const rowHeight = 1.8; // em — matches .website-by__emoji height
      const speed = 10; // rows per second
      const transformFor = (o) => 'translateY(' + (-o * rowHeight) + 'em)';
      let offset = 0;
      let rafId = null;
      let lastTime = 0;
      let spinning = false;

      function tick(t) {
        if (!spinning) return;
        if (!lastTime) lastTime = t;
        const dt = (t - lastTime) / 1000;
        lastTime = t;
        offset = (offset + speed * dt) % count;
        track.style.transform = transformFor(offset);
        rafId = requestAnimationFrame(tick);
      }

      function start() {
        if (spinning || reduced) return;
        spinning = true;
        lastTime = 0;
        track.style.transition = 'none';
        rafId = requestAnimationFrame(tick);
      }

      function stop() {
        if (!spinning) return;
        spinning = false;
        if (rafId) cancelAnimationFrame(rafId);
        track.style.transition = 'none';

        const randomIdx = Math.floor(Math.random() * count);
        let target = Math.ceil(offset + count * 0.4);
        target += ((randomIdx - (target % count)) + count) % count;
        const distance = target - offset;

        const v0 = speed;
        const a = (v0 * v0) / (2 * distance);
        let v = v0;
        let lastDecel = 0;

        function decel(t) {
          if (spinning) return;
          if (!lastDecel) lastDecel = t;
          const dt = (t - lastDecel) / 1000;
          lastDecel = t;
          v = Math.max(0, v - a * dt);
          offset = Math.min(target, offset + v * dt);
          track.style.transform = transformFor(offset);
          if (v > 0 && offset < target) {
            rafId = requestAnimationFrame(decel);
          } else {
            offset = target % count;
            track.style.transform = transformFor(offset);
          }
        }
        rafId = requestAnimationFrame(decel);
      }

      trigger.addEventListener('mouseenter', start);
      trigger.addEventListener('mouseleave', stop);
      trigger.addEventListener('focusin', start);
      trigger.addEventListener('focusout', stop);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
